import { Button } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import React from 'react';
import TableAction from '../../components/strategyProject/tabs/TabResults/TableAction/TableAction';
import style from '../../components/strategyProject/tabs/TabResults/TabResults.module.less';
import { getStrategyPermissions } from '../../services/rolesSvc';

export const status = {
  created: 'created',
  onApprove: 'onApprove',
  approved: 'approved',
  rejected: 'rejected',
};
export const status_ru = {
  created: 'Новая',
  onApprove: 'На согласовании',
  approved: 'Принята',
  rejected: 'Не согласована',
};
export const status_full = {
  created: { key: status.created, label: status_ru.created, bg: 'secondary' },
  onApprove: { key: status.onApprove, label: status_ru.onApprove, bg: 'warning' },
  approved: { key: status.approved, label: status_ru.approved, bg: 'success' },
  rejected: { key: status.rejected, label: status_ru.rejected, bg: 'danger' },
  // inProgress: { key: status.inProgress, label: status_ru.inProgress, bg: 'secondary' },
  // returned: { key: status.returned, label: status_ru.returned, bg: 'secondary' },
  // approved: { key: status.approved, label: status_ru.approved, bg: 'success' },
  // declined: { key: status.declined, label: status_ru.declined, bg: 'danger' },
  // onProjOffice: { key: status.onProjOffice, label: status_ru.onProjOffice, bg: 'warning' },
};
